"use client";

import React from "react";
import { useTranslations } from "i18n";
import { FILES } from "i18n/constants";
import { Button } from "app/_components/components/Button";

function CryptoConverterSmallCardBanner({
  coinName = "bitcoin"
}: {
  coinName?: string;
}) {
  const t = useTranslations(FILES.COMMON);

  const coinNameProcessed =
    coinName === "Bitcoin" ? coinName.toLowerCase() : coinName;

  return (
    <div
      className={`tablet:bg-[url(https://images.ctfassets.net/jg6lo9a2ukvr/5yd1RpljJ5TE8OqN3bx6zs/ae5cd6005a883d074abc96675261d2c8/image__5_.png?fm=webp)] w-full cursor-pointer rounded-[20px] bg-[url(https://images.ctfassets.net/jg6lo9a2ukvr/2Ofbd6pKnm8snhkmBEu7Uu/bd24eb72aacb49c25bc12b427cc4f695/image.png?fm=webp)] bg-cover p-6`}
      onClick={() => {
        window.open("https://www.gemini.com/converter/btc/usd", "_blank");
      }}
    >
      <div className="box-border">
        <div className="flex max-w-[500px] flex-col justify-start gap-4">
          <div
            className={`tablet:text-4xl! m-0! text-xl! leading-none font-semibold wrap-anywhere`}
          >
            {t("converterSmallCardTitle", { coinName: coinNameProcessed })}
          </div>
          <p
            className={`tablet:text-base text-sm leading-none font-semibold wrap-anywhere`}
          >
            {t("priceConverterSmallCardDescription", {
              coinName: coinNameProcessed
            })}
          </p>
          <Button
            className="tablet:h-14 tablet:px-8 tablet:text-base! h-10 w-auto flex-shrink-0 self-start px-6 py-2 text-sm!"
            size="md"
            variant="primary"
            asChild
          >
            <a
              target="_blank"
              href="https://www.gemini.com/converter/btc/usd"
              rel="noreferrer"
            >
              {t("priceConverterSmallCardCTALabel")}
            </a>
          </Button>
        </div>
      </div>
    </div>
  );
}
export default CryptoConverterSmallCardBanner;
